import { Image as ChakraImage, type ImageProps as ChakraImageProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ChakraImageProps {}

export default forwardRef<HTMLImageElement, Props>((props, ref) => {
  return <ChakraImage ref={ref} {...props} />
})